<template>
  <a-layout-content>
    <a-form-model
      layout="inline"
      ref="MemberForm"
      :model="input"
      :rules="rules"
    >
      <a-row>
        <a-col :span="24">
          <a-form-model-item label="账号" ref="txt_uid" prop="txt_uid">
            <a-input v-model="input.txt_uid" type="text" autocomplete="off" />
          </a-form-model-item>

          <a-form-model-item label="账号等级">
            <a-select
              v-model="input.drp_roletype"
              style="width: 100px"
              default-value="0"
              @change="query()"
            >
              <a-select-option value="0">--- 全部 ---</a-select-option>
              <a-select-option
                v-for="item in selectOption.Rolelist"
                :key="item.Role"
              >
                {{ item.RoleName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item>
            <a-button type="primary" html-type="submit" @click="query"
              ><a-icon type="search" style="font-size: 20px"
            /></a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

    <div class="body-nest">
      <a-table
        bordered
        row-key="UserID"
        size="middle"
        :columns="columns"
        :data-source="userrows"
        :pagination="pagination"
        :loading="loading"
        @change="changepage"
      >
        <template slot="title">
          <span></span>
          <a-row :gutter="24">
            <a-col :span="6" style="line-height: 30px">用户管理列表</a-col>
            <a-col style="float: right" >
              <a-button type="primary" @click="addUserModal" v-if="role59">新增用户</a-button>
            </a-col>
          </a-row>
        </template>

        <template slot="operation" slot-scope="text, record">
          <a-tooltip title="编辑用户" v-if="role60">
            <a @click="editModal(record)">
              <a-icon type="edit" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
          &nbsp;
          <a-tooltip title="白名单" v-if="role108">
            <a @click="showblocklist(record)">
              <a-icon
                type="safety-certificate"
                style="font-size: 22px"
              ></a-icon>
            </a>
          </a-tooltip>
        </template>
      </a-table>
    </div>

    <!-------------------------------------------------------弹窗部份--------------------------------------------------------->
    <a-modal
      v-model="visible"
      title="编辑用户基本讯息"
      width="40%"
      ok-text="储存"
      cancel-text="取消"
      @ok="onEditSubmit"
      layout="inline"
    >
      <a-form-model
        layout="inline"
        ref="MemberEditForm"
        :model="editPara"
        :rules="rules"
      >
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item label="账号" v-if="action == 'edit'">
              {{ editPara.txt_uid }}
            </a-form-model-item>
            <a-form-model-item label="账号" v-else-if="action == 'add'">
              <a-input
                v-model="editPara.txt_uid"
                type="text"
                autocomplete="off"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="名称">
              <a-input
                v-model="editPara.txt_name"
                type="text"
                autocomplete="off"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="密码">
              <a-input-password
                v-model="editPara.txt_password"
                type="password"
                autocomplete="off"
                @change="clearpwd2"
              />
            </a-form-model-item>

            <a-form-model-item label="确认密码">
              <a-input-password
                v-model="editPara.txt_password2"
                type="password"
                autocomplete="off"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item
              label="账号等级"
              ref="drp_roletype"
              prop="drp_roletype"
            >
              <a-select
                v-model="editPara.drp_roletype"
                style="width: 100px"
                default-value="1"
              >
                <a-select-option
                  v-for="item in selectOption.Rolelist"
                  :key="item.Role"
                >
                  {{ item.RoleName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item
              label="账号状态"
              ref="rad_state"
              prop="rad_state"
            >
              <a-switch
                checked-children="正常"
                un-checked-children="停用"
                :checked="editPara.rad_state.toString() == '1'"
                @change="swichstate($event)"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item
              label="google二次验证绑定状态"
              ref="rad_tfastate"
              prop="rad_tfastate"
            >
              <a-switch
                checked-children="绑定中"
                un-checked-children="未绑定"
                :checked="editPara.rad_tfastate.toString() == '1'"
                @change="swichtfastate($event)"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="备注" ref="txt_remark" prop="txt_remark">
              <a-textarea
                v-model="editPara.txt_remark"
                :auto-size="{ minRows: 3, maxRows: 10 }"
                class="areaSize"
              ></a-textarea>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <div v-if="action == 'edit'">
              <a-form-model-item
                label="创建时间"
                ref="sp_createtime"
                prop="sp_createtime"
              >
                {{ editPara.sp_createtime }}
              </a-form-model-item>

              <a-form-model-item
                label="最后更新"
                ref="sp_lastupdate"
                prop="sp_lastupdate"
              >
                {{ editPara.sp_editor + " [" + editPara.sp_ldt + "]" }}
              </a-form-model-item>
            </div>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <!-------------------------------------------------------弹窗结束--------------------------------------------------------->
    <!-- 白名单对话框 --------------------------------------------------------------------------------------------------------->
    <a-modal v-model="showBlock" title="编辑" @ok="saveblocklist">
      <a-form-model
        :model="formBlock"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="会员账号">
          <a-input v-model="formBlock.User" placeholder="会员账号" read-only />
        </a-form-model-item>
        <a-form-model-item label="白名单">
          <span style="color: red">每个IP用段行隔开</span>
          <a-textarea v-model="formBlock.IP" :rows="12" />
        </a-form-model-item>

        <a-form-model-item label="修改人">
          {{ formBlock.Editor }}
        </a-form-model-item>
        <a-form-model-item label="修改时间">
          {{ transdate(formBlock.Ldt) }}
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 白名单对话框 --------------------------------------------------------------------------------------------------------->
  </a-layout-content>
</template>

<script>
let userrows = [];

export default {
  data() {
    return {
      /*** 权限
        59	用户管理新增
        60	用户管理编辑
        108	用户管理编辑白名单
       */
      role59:false,
      role60:false,
      role108:false,
      collapsed: false,
      loading: false,
      visible: false,
      showBlock: false, //白名单弹窗
      formBlock: { User: "", IP: "", Editor: "", Ldt: "" }, //白名单字段
      RoleType: sessionStorage.RoleType,
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      action: "",
      input: {
        txt_uid: "",
        drp_roletype: "0",
        page: "1",
        pagesize: "10",
      },
      editPara: {
        txt_uid: "",
        txt_name: "",
        txt_password: "",
        txt_password2: "",
        txt_remark: "",
        drp_roletype: "1",
        rad_state: "1",
        sp_createtime: "",
        sp_editor: "",
        sp_ldt: "",
        rad_tfastate: "0"
      },
      selectOption: {
        Rolelist: [],
      },
      rules: {},
      //--table --
      columns: IninTable(),
      userrows,
      pagination: {
        total: 0,
      },
      //------------
    };
  },
  methods: {
    query() {
      this.$refs.MemberForm.validate((valid) => {
        if (valid) {
          let params = {
            UserID: this.input.txt_uid,
            RoleType: this.input.drp_roletype.toString(),
            pageindex: this.input.page,
            pagesize: this.input.pagesize,
          };

          this.axios.post("/mgruser/getmgruserlist", params).then((res) => {
            this.userrows = res.data;
            this.pagination.total = res.total;
          });
        } else {
          // 表单校验失败
          return false;
        }
      });
    },
    changepage(e) {
      this.input.page = e.current;
      this.input.pagesize = e.pageSize;
      this.query();
    },
    transdate(val) {
      return this.getDate(val, "yyyy-MM-dd HH:mm:ss");
    },
    addUserModal() {
      this.action = "add";
      this.visible = true;

      //初始参数
      this.editPara.txt_uid = "";
      this.editPara.txt_name = "";
      this.editPara.drp_roletype = 1;
      this.editPara.rad_state = "1";
      this.editPara.txt_password = "";
      this.editPara.txt_password2 = "";
      this.editPara.txt_remark = "";
      this.editPara.rad_tfastate = "0";
    },
    swichstate(val) {
      this.editPara.rad_state = val ? "1" : "0";
    },
    swichtfastate(val){
      this.editPara.rad_tfastate = val ? "1" : "0";
    },
    editModal(record) {
      this.action = "edit";
      this.visible = true;

      let params = {
        UserID: record.UserID,
      };

      this.axios
        .post("/mgruser/getmgruserdetailbyuserid", params)
        .then((res) => {
          //修改参数赋值
          this.editPara.txt_uid = res.data[0].UserID;
          this.editPara.txt_name = res.data[0].UserName;
          this.editPara.drp_roletype = res.data[0].RoleType;
          this.editPara.rad_state = res.data[0].UserState.toString();
          this.editPara.txt_password = res.data[0].PassWord;
          this.editPara.txt_password2 = res.data[0].PassWord;
          this.editPara.txt_remark = res.data[0].UserMemo;
          this.editPara.sp_createtime = res.data[0].CreateDate;
          this.editPara.sp_editor = res.data[0].EditUser;
          this.editPara.sp_ldt = res.data[0].EditDate;
          this.editPara.rad_tfastate = res.data[0].TFAState
        });
    },
    onEditSubmit() {
      var ActionName =
        this.action == "edit" ? "修改[" + this.editPara.txt_uid + "]" : "新增";

      if (this.editPara.txt_password != this.editPara.txt_password2) {
        this.$message.error("密码与确认密码不一致!");
        return false;
      }

      let _this = this;
      this.$confirm({
        title: "是否要" + ActionName + "帐号?",
        content: "是否要" + ActionName + "帐号?",
        onOk() {
          let params = {
            UserID: _this.editPara.txt_uid,
            UserName: _this.editPara.txt_name,
            PassWord: _this.editPara.txt_password,
            RoleType: _this.editPara.drp_roletype,
            UserState: _this.editPara.rad_state,
            UserMemo: _this.editPara.txt_remark,
            TFAState: _this.editPara.rad_tfastate,
          };

          var _Action = _this.action == "edit" ? "editmgruser" : "addmgruser";
          var postUrl = "/mgruser/" + _Action;

          _this.axios.post(postUrl, params).then((res) => {
            if (res.data) {
              _this.$message.success(ActionName + "账号成功!");
              _this.query();
            } else {
              _this.$message.error(res.error);
            }
          });
        },
        onCancel() {},
      });
    },
    clearpwd2() {
      this.editPara.txt_password2 = "";
    },
    getrolelist() {
      let params = {
        Role: 0,
        pageindex: 1,
        pagesize: 10,
      };

      this.axios.post("/role/getrolelist", params).then((res) => {
        this.selectOption.Rolelist = res.extend;
      });
    },
    //白名单
    showblocklist(record) {
      let IParr = "";
      this.showBlock = true;
      this.formBlock.User = record.UserID;

      let params = {
        Uid: record.UserID,
      };

      this.axios.post("/mgruser/getblocklistbyid", params).then((res) => {
        if (res.data.length != 0) {
          this.formBlock.Editor = res.data[0].Editor;
          this.formBlock.Ldt = res.data[0].Ldt;
          res.data.forEach(function (item) {
            IParr += item.IP + "\n";
          });
          this.formBlock.IP = IParr.slice(0, IParr.length - 1);
        } else {
          this.formBlock.Editor = "";
          this.formBlock.Ldt = "";
          this.formBlock.IP = "";
        }
      });
    },
    //保存白名单
    saveblocklist() {
      let iplist = [];
      let IPstr = this.formBlock.IP;
      let Uid = this.formBlock.User;
      let IPArray = IPstr.split(/[\s\n]/);
      let _this = this;
      let goon = true;
      IPArray.forEach(function (value) {
        const v4reg =
          /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        if (!v4reg.test(value) && value != "") {
          goon = false;
          return _this.$message.error(value + "请输入正确的ip");
        }
        var json = {};
        json["Uid"] = Uid;
        json["IP"] = value;
        iplist.push(json);
      });
      if (goon) {
        let params = {
          blocklist: iplist,
        };

        this.axios.post("/mgruser/saveblocklist", params).then((res) => {
          if (res.data) {
            this.$message.success("保存成功!");
          } else {
            this.$message.error(res.error);
          }
        });
      }
    },
  },
  created() {
    this.getrolelist();
    //获取权限
    const array = JSON.parse(sessionStorage.RoleID);
    const roleID = [59,60,61,106,107,108];
    var isRole = roleID.filter(function(item){
      return array.indexOf(item) != -1
    });
    //功能权限获取
    isRole.forEach(element => {
      this["role" + element] = true;
    });
  },
};

const IninTable = function IninTable() {
  var header = [];
  header.push({ title: "账号", align: "center", dataIndex: "UserID" });
  header.push({ title: "名称", align: "center", dataIndex: "UserName" });
  header.push({ title: "账号等级", align: "center", dataIndex: "RoleName" });
  header.push({
    title: "账号状态",
    align: "center",
    dataIndex: "UserState",
    filters: [
      { text: "停用", value: "0" },
      { text: "正常", value: "1" },
    ],
    customRender: (text) => {
      switch (text) {
        case 0:
          text = "停用";
          break;
        case 1:
          text = "正常";
          break;
      }
      return text;
    },
    onFilter: (value, record) =>
      record.UserState.toString().indexOf(value) === 0,
    sortDirections: ["descend"],
  });
  header.push({
    title: "创建时间",
    align: "center",
    sorter: (a, b) =>
      new Date(a.CreateDate.replace(/[\u4e00-\u9fa5]/g, "")).getTime() -
      new Date(b.CreateDate.replace(/[\u4e00-\u9fa5]/g, "")).getTime(),
    dataIndex: "CreateDate",
    ellipsis: true,
  });
  header.push({
    title: "最后更新",
    align: "center",
    customRender: (text, record) => {
      text = record.EditUser + " [" + record.EditDate + "]";
      return text;
    },
    sorter: (a, b) =>
      new Date(a.EditDate.replace(/[\u4e00-\u9fa5]/g, "")).getTime() -
      new Date(b.EditDate.replace(/[\u4e00-\u9fa5]/g, "")).getTime(),
  });
  header.push({ title: "备注", align: "center", dataIndex: "UserMemo" });
  header.push({
    title: "操作",
    align: "center",
    dataIndex: "operation",
    ellipsis: true,
    scopedSlots: { customRender: "operation" },
    width: 100,
  });
  return header;
};
</script>


<style>
.areaSize {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/adminmanage/mgruser.vue